import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import "./App.css";
import IndexPage from './page/IndexPage';
import SubCategoriaPage from './page/SubCategoriaPage';
import ManualesPage from './page/ManualesPage';

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path='/' element={<Navigate to='/inicio'/>} />
          <Route path='/inicio' element={<IndexPage />} />
          <Route path='/subcategoria' element={<SubCategoriaPage />} />
          <Route path='/manual' element={<ManualesPage />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
